
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 480 480","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M409.11 217.287c10.162 1.828 17.557 10.674 17.557 21v35.434c0 10.326-7.395 19.172-17.557 20.999l-21.149 3.805c-2.311 7.175-5.24 14.059-8.632 20.672l12.302 17.707c5.895 8.476 4.871 19.96-2.432 27.264l-25.053 25.052c-7.303 7.303-18.787 8.327-27.264 2.432l-17.706-12.309c-6.614 3.392-13.497 6.321-20.665 8.633l-3.805 21.148c-1.82 10.148-10.666 17.543-20.992 17.543h-35.435c-10.325 0-19.171-7.395-20.999-17.557l-3.804-21.149c-7.175-2.311-14.059-5.233-20.665-8.633l-17.707 12.31c-8.476 5.895-19.961 4.871-27.264-2.432l-25.052-25.053c-7.303-7.303-8.327-18.78-2.432-27.264l12.302-17.706c-3.392-6.614-6.322-13.497-8.633-20.672l-21.148-3.805c-10.148-1.82-17.543-10.667-17.543-20.992v-35.435c0-10.325 7.395-19.171 17.557-20.999l21.148-3.804c2.311-7.175 5.241-14.059 8.633-20.672l-12.302-17.707c-5.895-8.476-4.871-19.961 2.432-27.264l25.052-25.052c7.304-7.304 18.788-8.328 27.264-2.432l17.707 12.309c6.614-3.392 13.497-6.322 20.665-8.633l3.805-21.148c1.82-10.148 10.666-17.544 20.992-17.544h35.434c10.326 0 19.172 7.396 20.999 17.558l3.805 21.148c7.175 2.311 14.059 5.234 20.665 8.633l17.706-12.309c8.477-5.895 19.961-4.871 27.265 2.432l25.052 25.052c7.303 7.303 8.327 18.781 2.432 27.264l-12.302 17.707c3.392 6.613 6.322 13.497 8.633 20.672l21.134 3.797zM256 320c35.343 0 64-28.65 64-64 0-35.349-28.657-64-64-64-35.342 0-64 28.651-64 64 0 35.35 28.658 64 64 64z"}})])
          )
        }
      }
    